<template>
  <PartnershipEntrepreneurSection ref="partnershipEntrepreneur"></PartnershipEntrepreneurSection>
</template>

<script>
  import PartnershipEntrepreneurSection from "./PartnershipEntrepreneurSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "PartnershipEntrepreneurWrapper",
    components: {
      PartnershipEntrepreneurSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
